import { ObjectModel } from 'objectmodel';
import { tokenType } from '../../lib/constants';

const Token = new ObjectModel({
  kid: String,
  macKey: String,
  type: Object.values(tokenType)
}).defaultTo({
  type: tokenType.RESTRICTED
});

export { Token };



/** WEBPACK FOOTER **
 ** ./~/kaistore-post-messenger/src/models/Auth.js
 **/